import { Number as IntlNumber } from "react-intl-number-format";

function LeaderboardEntry ( { name, number, distance, greatestDistance, progressPercent, isMyTeam } ) 
{
    const widthPercent = progressPercent * 100 * distance / greatestDistance;

    return  <>
                <div className={"text-sm xs:text-lg mb-4" + ( isMyTeam ? " border-l-8 border-l-pgorange py-4 pl-2 pr-4" : " m-4" )}>
                    <div className="flex flex-row justify-between">
                        <div className={( isMyTeam ? " text-pgdarkteal" : " text-pgdarkteal" ) + " font-bold pb-2"}>{number + ". " + name + ( isMyTeam ? " (Your Team)" : "" )}</div>
                        <div className={( isMyTeam ? " text-pgdarkteal" : " text-pgdarkteal" ) + " flex flex-row font-bold"}>
                            <IntlNumber className="inline-block">{ distance.toFixed ( 0 )}</IntlNumber>
                            <span>&nbsp;km</span>
                        </div>
                    </div>
                    <div>
                        <div style={{width: widthPercent + "%"}} className="bg-pgorange h-4" />
                    </div>
                </div>
                <hr className="mt-4 border-pglightteal border-dashed" />
            </>
}

export default LeaderboardEntry;
